<template>
  <div>
    <div v-if="paymentHistory && paymentHistory.length > 0" class="mt-3">
      <v-card-text>
        <v-layout row wrap>
          <v-subheader class="queryLabel pl-2">Payment History</v-subheader>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-layout>
      </v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table :headers="headers" :items="paymentHistory" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.paytRefNo }}</td>
              <td class="text-xs-right">{{ formatDisplayNumber(props.item.paymentAmt) }}</td>
              <td class="text-xs-right">{{ props.item.success? 'Yes' : 'No' }} </td>
              <td class="text-xs-right">{{ formatDisplayDateTime(props.item.createdDate) }} </td>
              <td class="text-xs-right">
                <table-action :rowData="props" :query="true" @query="doQuery(props)"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog v-model="paymentDialog" width="500">
        <v-card v-if="selectedPayment">
          <v-card-title class="headline grey lighten-2" primary-title>
            <div>
              {{selectedPayment.item.paytRefNo}}
            </div>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="paymentDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Currency</v-subheader>
                  <div>{{selectedPayment.item.currency}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Amount</v-subheader>
                  <div>{{formatDisplayNumber(selectedPayment.item.paymentAmt)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Success</v-subheader>
                  <div>{{selectedPayment.item.success? 'Yes' : 'No'}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Card Type</v-subheader>
                  <div>{{ccType(selectedPayment.item.ccType)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Payment Date</v-subheader>
                  <div>{{formatDisplayDateTime(selectedPayment.item.createdDate)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">Payment Code</v-subheader>
                  <div>{{selectedPayment.item.errorCode ? selectedPayment.item.errorCode : '-'}}</div>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="queryLabel">Message</v-subheader>
                  <div>{{selectedPayment.item.message}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDateTime } from '@/utils/date'
import { ccType } from '@/const/underwriting'
export default {
  data() {
    return {
      headers: [
        { text: 'Ref No.', align: 'left', value: 'paytRefNo' },
        { text: 'Amount', align: 'right', value: 'paymentAmt' },
        { text: 'Success', align: 'right', value: 'success' },
        { text: 'Date', align: 'right', value: 'createdDate' },
        TableConst.tableActionHeader
      ],
      search: undefined,
      selectedPayment: null,
      paymentDialog: false
    }
  },
  computed: {
    paymentHistory() {
      return this.$store.state.agency.quotation.commonInfo.paymentHistory
    }
  },
  methods: {
    formatDisplayNumber(num) {
      return formatDisplayNumber(num)
    },
    formatDisplayDateTime(date) {
      return formatDisplayDateTime(date)
    },
    doQuery(props) {
      this.selectedPayment = props
      this.paymentDialog = true
    },
    ccType(type) {
      return ccType[type]
    }
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style>
</style>
